function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { PageToolbar, PageToolbarItem } from "@sprout/client-components/dist/PageToolbar";
import { MenuTrigger, useMenuState } from "@sprout/list-navigation/dist/Menu";
import { Box } from "sprout-ui-primitives";
import { useIsMyTasksPageOnboard, useIsReadLaterPageOnboard, useIsTopicPageOnboard } from "@sprout/hooks/dist/onboard";
import { MoreHoriz, LeafLine, GitBranchLine } from "sprout-ui-icons";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import { getIsLargePointerDevice } from "sprout-ui-dom/dist/utils";
import { useTopicPageViewsTopicEditor } from "./TopicPageViewsTopicEditorContext";
import TopicPageViewsTopicMenu from "./TopicPageViewsTopicMenu";
import useTopicAuthorization from "./useTopicAuthorization";
const TopicPageViewsTopicToolbar = (props)=>{
    const { topic  } = props;
    const authorization = useTopicAuthorization(topic);
    //
    const { dispatch  } = useTopicPageViewsTopicEditor();
    useActionRegistryGlobalHandler("ADD_SECTION", useCallback((_activeItems, event)=>{
        /**
         * Required in Chrome, prevent the letter `S` from filling the input
         */ event === null || event === void 0 ? void 0 : event.preventDefault();
        dispatch({
            type: "SET_EDITOR",
            payload: {
                editor: "CREATE_SECTION",
                variant: getIsLargePointerDevice() ? "desktop" : "mobile"
            }
        });
        return true;
    }, [
        dispatch
    ]), {
        skip: !authorization.addSection
    });
    //
    const { rootTopicOrSelf  } = topic;
    const { special  } = rootTopicOrSelf || {};
    const [isTopicPageOnboard] = useIsTopicPageOnboard();
    const [isMyTasksPageOnboard] = useIsMyTasksPageOnboard();
    const [isReadLaterPageOnboard] = useIsReadLaterPageOnboard();
    const showPulse = !isTopicPageOnboard && !special || !isMyTasksPageOnboard && special === "MY_TASKS" || !isReadLaterPageOnboard && special === "INBOX";
    const isTopicEmpty = topic.posts.totalCount === 0 && topic.sections.totalCount === 0;
    //
    const menuState = useMenuState();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Box, {
                height: "32px"
            }),
            /*#__PURE__*/ _jsxs(PageToolbar, {
                $stickyWithBottomNavigation: true,
                children: [
                    authorization.addLeaf && /*#__PURE__*/ _jsx(PageToolbarItem, {
                        icon: LeafLine,
                        label: "Leaf",
                        action: "ADD_POST",
                        pulse: showPulse && isTopicEmpty
                    }),
                    authorization.addSection && /*#__PURE__*/ _jsx(PageToolbarItem, {
                        icon: GitBranchLine,
                        label: "Branch",
                        action: "ADD_SECTION"
                    }),
                    /*#__PURE__*/ _jsx(MenuTrigger, _objectSpread({}, menuState, {
                        children: /*#__PURE__*/ _jsx(PageToolbarItem, {
                            icon: MoreHoriz,
                            label: "More"
                        })
                    }))
                ]
            }),
            /*#__PURE__*/ _jsx(TopicPageViewsTopicMenu, {
                topic: topic,
                menuState: menuState
            })
        ]
    });
};
export default TopicPageViewsTopicToolbar;
